import { useDebouncedState } from '@mantine/hooks';
import { ChangeEvent } from 'react';

import { Author } from '@feature/utils';

interface FilterAvailableType {
  id: number;
  title: string;
  authors: Author[];
}

interface UseFilterAvailableOptions<T extends FilterAvailableType> {
  available: T[];
  selected: T[];
}

export function useFilterAvailable<T extends FilterAvailableType>({
  available,
  selected,
}: UseFilterAvailableOptions<T>) {
  const [value, setValue] = useDebouncedState('', 200);

  const selectedMap: Record<number, boolean> = selected.reduce(
    (acc, next) => {
      acc[next.id] = true;
      return acc;
    },
    {} as Record<number, boolean>,
  );
  const options = available
    .filter(op => !selectedMap[op.id])
    .filter(op => {
      const titleMatch = op.title.toLowerCase().indexOf(value.toLowerCase()) !== -1;
      const authorsMatch =
        op.authors.filter(au => au.userName.toLowerCase().indexOf(value.toLowerCase()) !== -1).length > 0;

      return titleMatch || authorsMatch;
    });

  return {
    searchProps: {
      defaultValue: value,
      onChange: (event: ChangeEvent<HTMLInputElement>) => setValue(event.currentTarget.value),
    },
    options,
  };
}
